import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../../../store/applicationState';
import { GetCerteficate, UpdateCerteficate, UpdateCerteficateProfile } from '../../../../store/certeficate/actions';
import { TFinalTest } from '../../../../store/finalTest/types';
import { IconCry } from '../../../svgs/IconCry';
import * as Styles from '../../../Certificates/styles';
import { Button } from '../../../../test/components/ui';
import { ChangeFio } from '../../../modals';
import { Loader } from '../../../ui/Loader';
import { CheckUser } from '../../../../store/users/actions';
import { FormCerteficate, IFormValues } from '../../../Certificates/FormCerteficate';

interface PropsType {
  test: TFinalTest;
  type: 'success' | 'fail';
}

const ResultMessage: React.FC<PropsType> = ({ type, test }) => {
  if (type === 'success' && test.isDone && test.quantity > 1) {
    return (
      <>
        <h2>Вітаю! Ви пройшли тест успішно!</h2>
        <h3>Ви набрали: «{test.points}» балів.</h3>
      </>
    );
  }

  if (type === 'success' && test.isDone) {
    return (
      <>
        <h2>Вітаю! Ви здали тест з першого разу!</h2>
        <h3>Ви набрали «{test.points}» балів.</h3>
      </>
    );
  }
  if (type === 'fail' && test.quantity > 1) {
    return (
      <h2>
        <IconCry />
        Тест не здано. Прохідний бал складає «{test.minPoints}». Ви набрали «{test.points}» балів. Пройдіть тестування повторно.
      </h2>
    );
  }
  if (type === 'fail') {
    return (
      <h2>
        <IconCry />
        Шкода, тест не здано. Ви набрали «{test.points}» балів. Прохідний бал складає «{test.minPoints}». Спробуйте ще раз.
      </h2>
    );
  }
  return null;
};

export const TextMessageMed: React.FC<PropsType> = ({ test, type }) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [isModal, setIsModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const { Sockets, Users, Certeficate } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const generateCertificate = () => {
    if (!Sockets.event || !Users.user) return null;
    let fio_ua = Users.user.fio;
    if (!isEdit && Certeficate.data?.entity?.fio_ua && Users.user.fio.length < Certeficate.data.entity.fio_ua.length) {
      fio_ua = Certeficate.data.entity.fio_ua;
    }
    setLoading(true);
    dispatch(
      UpdateCerteficate.request({
        data: {
          event_id: Sockets.event.absnum,
          fio_ua,
        },
        callBack: (succ, data) => {
          if (succ && data.cert_pdf && data.message === 'ok' && Sockets.event) {
            dispatch(
              GetCerteficate.request({
                data: { event_id: Sockets.event.absnum },
                callBack: () => {
                  window.open(data.cert_pdf);
                },
              })
            );
          } else {
            setLoading(false);
          }
        },
      })
    );
  };

  const handleChange = (values: IFormValues, callback: (success: boolean, message?: string) => void) => {
    if (!Sockets.event) return null;
    if (loading) return null;

    setLoading(true);
    dispatch(
      UpdateCerteficateProfile.request({
        data: {
          event_id: Sockets.event.absnum,
          ...values,
        },
        callBack: (succ, data) => {
          if (!succ && typeof data === 'string') {
            callback(succ, data);
          }
          setLoading(false);
        },
      })
    );
  };

  if (!test.isDone) return <ResultMessage test={test} type={type} />;

  if (Certeficate.error)
    return (
      <Styles.ModalBodyS>
        <h4 style={{ textAlign: 'center' }}>Виникла помилка</h4>
      </Styles.ModalBodyS>
    );

  if (!Certeficate.data?.certeficate?.is_profile && Certeficate.data?.certeficate?.is_done && test && test?.isDone) {
    return (
      <>
        <Styles.HeadingS>{test.quantity === 1 ? 'Вітаю! Ви здали тест с першого разу!' : 'Вітаю! Ви пройшли тест успішно!'}</Styles.HeadingS>
        <FormCerteficate
          data={{
            workPlace: Users.user?.company,
            email: Users.user?.email,
            phone: Users.user?.phone,
            education: '',
            position: '',
            dateBirth: '',
          }}
          title={'Дані для отримання сертифіката'}
          description={
            'Через нові вимоги МОЗ до сертифікатів, які надають право медикам отримати бали БПР, ми змушені попросити Вас вказати додаткові дані, інакше, ми не зможемо подати сертифікат на реєстрацію.'
          }
          handleSubmit={handleChange}
        />
      </>
    );
  }

  if (
    Certeficate.data?.entity?.cert_pdf &&
    Number(Certeficate.data.entity.is_change) > 0 &&
    Sockets.event &&
    new Date(Sockets.event.dateEnd) < new Date()
  )
    return (
      <Styles.ModalBodyS style={{ textAlign: 'center' }}>
        <h4>Сертифікат можете скачати за даним посиланням</h4>
        <a href={Certeficate.data.entity.cert_pdf} target="_blank" rel="noreferrer" style={{ color: '-webkit-link', textDecoration: 'underline' }}>
          {Certeficate.data.entity.cert_pdf}
        </a>
      </Styles.ModalBodyS>
    );

  if (Sockets.event && new Date(Sockets.event.dateEnd) < new Date()) {
    return (
      <>
        <Styles.ModalBodyS style={{ textAlign: 'center' }}>
          <h4>Перевірте правильність написання Вашого імені, саме так буде вказано в сертифікаті.</h4>
          <h2 style={{ textAlign: 'center' }}>{Users.user?.fio}</h2>
        </Styles.ModalBodyS>
        <Styles.ModalFooterS>
          <Styles.WrapBtn>
            <Button onClick={() => setIsModal(true)} title="Є помилка" />
            <Button onClick={generateCertificate} title="Все вірно" />
          </Styles.WrapBtn>
        </Styles.ModalFooterS>
        {loading && <Loader />}
        {isModal && (
          <ChangeFio
            changeHandler={() => setIsEdit(true)}
            closeHandler={() => {
              setIsModal(false);
              Sockets.event && dispatch(CheckUser.request({ data: { event_id: Sockets.event.absnum } }));
            }}
          />
        )}
      </>
    );
  }
  return <ResultMessage test={test} type={type} />;
};
